const advancedFilterCondition = {
    Equals: 0,
    NotEquals: 1,
    Contains: 2,
    NotContains: 3,
    In: 4,
    NotIn: 5,
    LesserThan: 6,
    LesserEqual: 7,
    GreaterThan: 8,
    GreaterEqual: 9
}

export { advancedFilterCondition };